export default "__VITE_PUBLIC_ASSET__18e10cbc__"